import './BattleAttach.sass';

import React, { FC, useMemo } from 'react';

import { BattleAttachProps } from './BattleAttach.interface';
import { IcContest28, IcWheel28 } from '$assets';

import { goTo } from '$navigation/helper';
import { BATTLE } from '$shared/constants/pages';
import { useTranslator } from '$hooks';

export const BattleAttach: FC<BattleAttachProps> = ({ battlePrize }) => {
  const [one, two] = [battlePrize.modelOne, battlePrize.modelTwo];
  const description = `${one.firstName} ${one.lastName.substring(0, 1)} vs ${
    two.firstName
  } ${two.lastName.substring(0, 1)}`;
  const t = useTranslator();

  return (
    <div
      className="BattleAttach"
      onClick={() => {
        goTo(BATTLE, { id: battlePrize.battleId });
      }}
    >
      <div className="BattleAttach__info">
        <div className="BattleAttach__info__title">{t('attach_battle_prize_title')}</div>
        <div className="BattleAttach__info__description">{description}</div>
      </div>
      <div className="BattleAttach__icon">
        <IcContest28 />
      </div>
    </div>
  );
};
